import 'angular';
import 'angular-cookies';
import 'angular-css';
import 'angular-route';
import 'angular-sanitize';
import 'angular-uuid';
import 'angular-mocks';

import 'moment';
import 'moment-timezone';
import 'jstz';

import 'ng-device-detector';

import 'core-js/stable';
import 'regenerator-runtime/runtime';

import 'owlcarousel-pre/owl-carousel/owl.carousel';

import '@zeitiger/elevatezoom/jquery.elevatezoom';

// jQuery 3+ removed event shorthand methods like `$(window).load(fn)`; older third-party
// libraries (e.g., Foundation 5.5.3) still call them. Restore compatibility here while
// preserving the AJAX `$(el).load(url, ...)` signature.
const $ = require('jquery');

if ($ && $.fn) {
    // Foundation 5 checks `i.selector` to decide whether an argument is a jQuery object.
    // jQuery 3 removed the `.selector` property, which causes Foundation to fall back to
    // `$(document)` and call `.css()` on a document node (crashing in jQuery 3.7+).
    if (typeof $.fn.selector === 'undefined') {
        $.fn.selector = '';
    }

    const shimEventShortcut = (eventName) => {
        const original = $.fn[eventName];

        $.fn[eventName] = function (...args) {
            if (args.length === 0) {
                return this.trigger(eventName);
            }

            if (typeof args[0] === 'function') {
                return this.on(eventName, args[0]);
            }

            if (typeof original === 'function') {
                return original.apply(this, args);
            }

            return args.length ? this : this.trigger(eventName);
        };
    };

    shimEventShortcut('load');
    shimEventShortcut('error');
    shimEventShortcut('unload');
}

require('../resource/lib/modernizr.min.js');
require('../resource/lib/foundation.min.js');

require('./app.module');
require('./app.route');

const loaded = new Set();

const loadAll = (context, expr) => {
    context.keys().forEach(k => {
        if (loaded.has(k) || (expr && !expr.test(k))) {
            return;
        }

        loaded.add(k);

        context(k);
    });
};

const css = require.context('../resource/css', true, /\.css$/);
loadAll(css, /\d\.\d\.\d/); // third party styles
loadAll(css, /googlefonts/);
loadAll(css, /app.foundation/);
loadAll(css, /parent/);
loadAll(css, /modalStyle/);
loadAll(css, /custom.foundation/);

const modules = require.context('./', true, /\.module\.js$/);
loadAll(modules);

const remaining = require.context('./', true, /^(.(?!(app\.bootstrap|module|tests|spec)))*\.js$/);
loadAll(remaining);

// Add our utilities functions to the window scope
Object.assign(window, require('../resource/lib/utilities'));




// WEBPACK FOOTER //
// ./app/app.dependencies.js